// extracted by mini-css-extract-plugin
module.exports = {"winImage":"BuyLinks-module--winImage--2LVgJ","macLink":"BuyLinks-module--macLink--Y0XT4","macImage":"BuyLinks-module--macImage--1n7jD"};